<template>
    <Section
        v-if="enabled"
        width="sm"
    >
        <div class="container">
            <Author
                :id="document.data.author.id"
                :show-articles="false"
                :sources="sources"
            />
            <div v-if="englishPage" class="rich-text english-link">
                <nuxt-link :to="$prismic.linkResolver(englishPage)">
                    <i class="fa-solid fa-globe" /> This page in english
                </nuxt-link>
            </div>
            <Editor 
                :document-editor="document.data.editor"
            />
        </div>
    </Section>
</template>

<script>
import Author from '@/components/slices/lists/list-items/ListItemAuthor.vue';
import Editor from '@/components/Editor.vue';
export default {
    components: { Author, Editor },
    props: {
        document: {
            type: Object,
            required: true
        }
    },
    computed: {
        enabled() {
            return this.document.data.author.id;
        },
        englishPage() {
            const englishVersion = this.document.data.english_version;
            if (this.$validateContentRelationship(englishVersion)) {
                return englishVersion;
            }
            return null;
        },
        sources() {
            return this.document.data.sources
                .map(iterator => iterator.source)
                .filter(source => source);
        },
    }
};
</script>

<style lang="scss" scoped>
    section::v-deep {
        .container {
            @include spacing(padding,4);
            background: $lightgray;
            box-shadow: $bxs;
            @include border-radius(5px);

            .english-link {
                @include spacing(padding, 2);
                @include spacing(margin, 4, top);
                @include border-radius(5px);
                @include font-size(14px);
                background: $white;
                a {
                    color: $green;
                    i {
                        color: $blue;
                        margin-right: 5px;
                    }
                }
                a:hover {
                    text-decoration: underline;
                }
            }
        }
    }
</style>
